import type { OptionBalance } from '@talos/kyoko';
import {
  OPTION_BID_IV,
  OPTION_BID_PRICE,
  OPTION_BID_SIZE,
  OPTION_DELTA,
  OPTION_GAMMA,
  OPTION_LAST_PRICE,
  OPTION_MARK,
  OPTION_OFFER_IV,
  OPTION_OFFER_PRICE,
  OPTION_OFFER_SIZE,
  OPTION_POSITION,
  OPTION_RHO,
  OPTION_SPREAD,
  OPTION_STRIKE_PRICE,
  OPTION_THETA,
  OPTION_VEGA,
  OPTION_VOLUME,
  type OptionChainSideData,
} from './types';

export const OPTION_CHAIN_TOOLTIPS = {
  [OPTION_LAST_PRICE]: 'Last traded price on this option from the exchange',
  [OPTION_RHO]: 'Rho value of the option from the exchange',
  [OPTION_VEGA]: 'Vega value of the option from the exchange',
  [OPTION_GAMMA]: 'Gamma value of the option from the exchange',
  [OPTION_THETA]: 'Theta value of the option from the exchange',
  [OPTION_DELTA]: 'Delta value of the option from the exchange',
  [OPTION_VOLUME]: 'Total exchange volume traded on this option in the last 24 hours',
  [OPTION_BID_SIZE]: 'Total size of the best bid on this option on the exchange',
  [OPTION_BID_IV]: 'Implied volatility of the best bid price on this option from the exchange',
  [OPTION_BID_PRICE]: 'Best bid price on this option on the exchange',
  [OPTION_SPREAD]: 'Spread between best bid/offer for this option on the exchange',
  [OPTION_MARK]: 'Mark price on this option on the exchange',
  // Not currently used in the option chain hence no constant
  MarkPriceIV: 'Implied volatility of the mark price on this option from the exchange',
  [OPTION_OFFER_PRICE]: 'Best offer price on this option on the exchange',
  [OPTION_OFFER_IV]: 'Implied volatility of the best offer price on this option from the exchange',
  [OPTION_OFFER_SIZE]: 'Total size of the best offer on this option on the exchange',
  [OPTION_POSITION]: 'Number of open position contracts on this option on the exchange',
  [OPTION_STRIKE_PRICE]: 'The strike price is the exercise price of an option',
} satisfies Partial<Record<keyof OptionChainSideData | 'StrikePrice', string>>;

export const OPTION_BALANCES_TOOLTIPS = {
  AvailableMargin:
    'For a PM account the amount of equity that is still not reserved by exchange by the initial margin. \n For a SM account the amount of available margin that is still not reserved by exchange by the initial margin.',
  Equity: 'The total Equity value on your exchange account/sub-account.',
  InitialMargin: 'The amount of margin reserved by exchange for your open positions and open orders.',
  MaintenanceMargin: 'The margin required by exchange to maintain your current positions.',
} satisfies Partial<
  Record<keyof Pick<OptionBalance, 'Equity' | 'AvailableMargin' | 'InitialMargin' | 'MaintenanceMargin'>, string>
>;
